import type { RouteLocationRaw } from "vue-router"

export interface Breadcrumb {
  to: RouteLocationRaw
  label: string
}

const breadcrumbs = ref<Breadcrumb[]>([])

export const useBreadcrumbs = () => {
  return {
    breadcrumbs,
  }
}
